import {debounce} from "../components/debounce";
import type {FormData, Step} from "./types";

const KEY = 'vragenlijst_psycholoog_form_data';

export interface SessionData {
    data: FormData;
    step: Step;
}

function store(data: FormData, step: number) {
    const json = JSON.stringify({
        data, step
    });
    localStorage.setItem(KEY, json);
}

function load(): SessionData | null {
    const json = localStorage.getItem(KEY);
    if (!json) return null;

    try {
        return JSON.parse(json) as SessionData;
    } catch (e) {
        console.error('Error parsing form data from localStorage:', e);
        return null;
    }
}

const debouncedStore = debounce(store, 500);

function clear() {
    localStorage.removeItem(KEY);
}

export const Session = {
    store: debouncedStore,
    load,
    clear
}
